import "../../styles/policy/Policy.css";

const Policy = () => {
    // https://www.go-elibrary.co.kr/member/policy.asp
    // 레퍼런스 사이트
    return (
        <div className="policy-container">
            <div className="policy-box">

                <div className="policy-title">
                    <h2>서비스 이용약관</h2>
                    <p className="policy-detail-box"><b>(주)The Japan</b>은 회원님들의 권익을 보호하고, 회원님들의 개인정보 보호에 만전을 기하고자 관계법령의
                        규정을 반영하여
                        약관을 규정하였습니다.</p>
                </div>

                <div className="policy-content">
                    <div>
                        <div>
                            <p className="policy-detail-title">● 제 1장 총칙</p>
                        </div>
                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 1조 (목적)</p>
                            </div>
                            <div>
                                <p className="policy-detail-content">이 약관은 전기통신사업법, 전기통신기본법, 정보통신 윤리위원회 심의규정, 정보통신 윤리강령, 프로그램 보호법 및 관계규정에 의거 (주)The Japan이
                                    제공하는
                                    교육 서비스의 이용조건 및 절차에 관한 사항과 기타 필요한 사항의 준수 및 규정함을 목적으로 합니다.
                                </p>
                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 2조 (약관의 효력 및 변경)</p>
                            </div>
                            <div className="policy-detail-box">
                                <p>1. 이 약관의 내용은 이용자가 정해진 등록절차를 거쳐 등록을 완료하면 이 약관에 동의한 것으로 간주합니다.</p>
                                <p>2. The Japan은 이 약관을 변경할 수 있으며 변경된 약관은 서비스 화면에 게시하거나 기타 방법으로 회원에게 공지함으로써 그 효력이
                                    발생합니다.</p>
                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 3조 (약관의 수정)</p>
                            </div>
                            <div>
                                <p className="policy-detail-content">The Japan은 합리적 사유가 발생했을 경우 서비스 약관의 내용을 변경할 수 있습니다. 다만 변경된 내용은 이용자에게 공지함으로써 효력을 발생합니다.
                                    The Japan은 변경된 약관을 초기화면에 공지함으로써 이용자는 직접 확인할 수 있습니다. 이용자는 변경된 약관에 동의하지 않을 경우 등록을 취소할 수
                                    있으며,
                                    서비스를 계속 이용할 경우 약관 변경에 대한 동의로 간주합니다.</p>
                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 4조 (약관 외 준칙)</p>
                            </div>
                            <div>
                                <p className="policy-detail-content">이 약관에 명시되지 않은 사항은 관계 법령에 규정되어 있을 경우 그 규정에 따르며, 그렇지 않은 경우에는 일반적인 관례에 따릅니다.</p>
                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 5조 (용어의 정의)</p>
                            </div>
                            <div className="policy-detail-box">
                                <p>1. 홈페이지 회원 : The Japan에서 회원가입을 통하여 ID를 발급받은 자</p>
                                <p>2. 이용자 번호(ID) : 이용자 식별과 이용자의 서비스 이용을 위하여 이용계약 체결 시 홈페이지 회원에게 The Japan이 부여하는 문자와 숫자의
                                    조합.</p>
                                <p>3. 비밀번호: 홈페이지 자신의 비밀을 보호하기 위하여 이용자 자의로 설정한 문자와 숫자의 조합</p>
                                <p>4. 단말기: The Japan의 서비스 제공을 받기 위해 이용자가 설치한 개인용 컴퓨터 및 모뎀 등의 기기</p>
                                <p>5. The Japan 이용: 이용자가 단말기를 이용하여 The Japan에 접속하여 The Japan이 제공하는 정보를 이용하는 것</p>
                                <p>6. 인터넷 서비스: 전세계의 컴퓨터 네트워크들과 연결되어 제공하는 전자우편, 파일전송, 원격지 로그인, 웹 등의 서비스</p>
                                <p>7. 인터넷 서비스 제공자(ISP): 인터넷 회선 및 인터넷 서비스를 제공하는 기관 또는 사람.</p>
                            </div>
                        </div>

                    </div>

                    <div>
                        <div>
                            <p className="policy-detail-title">● 제 2장 서비스의 이용</p>
                        </div>
                        <div>
                            <div className="policy-detail-subTitle">◇ 제 1조 (서비스 이용시간)</div>
                            <div>
                                <p className="policy-detail-content">서비스의 이용 시간은 The Japan의 업무 및 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간(00:00-24:00)을 원칙으로 합니다.
                                    다만, 정기 점검 등의 필요로 The Japan이 정한 날이나 시간은 그러하지 아니합니다. 이 경우는 The Japan의 공지사항을 통하여
                                    공지합니다. 고객문의는 평일 오전 9시부터 오후 6시, 주말 및 공휴일은 휴무입니다. 이는 운영상황에 따라 변경이 될 수 있습니다.</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 2조 (이용자 번호 등)</p>
                            </div>
                            <div className="policy-detail-box">
                                <p>1. 이용자번호 및 비밀번호에 대한 모든 관리책임은 이용자에게 있습니다.</p>
                                <p>2. 명백한 사유가 있는 경우를 제외하고는 이용자가 이용자번호를 공유, 양도 또는 변경할 수 없습니다.</p>
                                <p>3. 이용자에게 부여된 이용자번호에 의하여 발생되는 서비스 이용상의 과실 또는 제3자에 의한 부정사용 등에 대한 모든 책임은 이용자에게 있습니다.</p>
                            </div>
                        </div>
                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 3조 (서비스 이용의 제한 및 이용계약의 해지)</p>
                            </div>
                            <div className="policy-detail-box">

                                <p>1. 이용자가 서비스 이용계약을 해지하고자 하는 때에는 회원 본인이 온라인으로 The Japan에 해지신청을 하여야 합니다.</p>
                                <p>2. The Japan은 이용자가 다음 각 호에 해당하는 경우 사전 통지 없이 이용계약을 해지할 수 있습니다.</p>

                                <div>

                                    <p>1. 타인의 이용자번호를 사용한 경우</p>
                                    <p>2. 서비스의 운영을 고의로 방해한 경우</p>
                                    <p>3. 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우</p>
                                    <p>4. 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</p>
                                    <p>5. 기타 The Japan의 이용자로서 부적당하다고 판단한 경우</p>

                                </div>
                                <p>위의 2항에 의하여 이용 제한을 당한 회원은 이용 중지에 대하여 이의가 있을 경우 전자메일을 통하여 이의 신청을 할 수 있습니다.</p>
                                <p>3. 회원탈퇴를 하시면 The Japan을 사용하면서 발생되었던 서비스 구매 내역 등의 모든 개인정보는 삭제가 됩니다.</p>
                                <p>4. 서비스 이용 중에 입력된 게시물들에 대한 개별 제공은 불가합니다.</p>

                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 3조 (이용자 게시물의 삭제 및 서비스 이용 제한)</p>
                            </div>
                            <div className="policy-detail-box">

                                <p>1. The Japan은 서비스용 설비의 용량에 여유가 없다고 판단되는 경우 필요에 따라 이용자가 게재 또는 등록한 내용물을 삭제할 수 있습니다.</p>
                                <p>2. The Japan은 서비스용 설비의 용량에 여유가 없다고 판단되는 경우 이용자의 서비스 이용을 부분적으로 제한할 수 있습니다.</p>
                                <p>3. The Japan은 이용자가 게재 또는 등록하는 서비스내의 내용물이 다음 각 호에 해당한다고 판단되는 경우에 이용자에게 사전 통지 없이 삭제할
                                    수 있습니다.</p>

                                <div className="policy-detail-subBox">

                                    <p>1. 다른 이용자 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 경우</p>
                                    <p>2. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 유포하는 경우</p>
                                    <p>3. 반국가적, 반사회적, 범죄적 행위와 결부된다고 판단되는 경우</p>
                                    <p>4. 다른 이용자 또는 제 3자의 저작권 등 기타 권리를 침해하는 경우</p>
                                    <p>5. 게시 기간이 규정된 기간을 초과한 경우</p>
                                    <p>6. 기타 관계 법령에 위배된다고 판단되는 경우</p>

                                </div>
                            </div>
                        </div>

                        <div>
                            <div>
                                <p className="policy-detail-subTitle">◇ 제 4조 (서비스 제공의 중지 및 제한)</p>
                            </div>
                            <div className="policy-detail-box">
                                <p>
                                    The Japan은 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있습니다.
                                </p>
                                <div className="policy-detail-subBox">
                                    <p>1. 서비스용 설비의 보수 또는 공사로 인한 부득이한 경우</p>
                                    <p>2. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 때</p>

                                </div>
                                <p>The Japan은 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때에는 서비스 제공을 중지하거나 제한할
                                    수 있습니다.</p>
                            </div>
                        </div>


                    </div>

                </div>

            </div>
        </div>
    )
}

export default Policy;
